<template>
  <div class="weather-icon">
    <img :src="weatherIconUrl" />
    <span class="title">{{ currentWeather.temperature}} &#8451;</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WeatherIcon',
  props: {
    current: Object,
    weatherIcon: String,
    temperature: String
  },
  computed: {
    ...mapGetters({
      currentWeather: 'dataWeatherCurrent',
    }),
    weatherIconUrl: function () {
      if (this.currentWeather.icon === "") {
        return ''
      }
      return `http://openweathermap.org/img/w/${this.currentWeather.icon.split(',')[0]}.png`
    },
  }
}
</script>

<style scoped>
.title {
  font-size: 0.8em;
  padding-right: 10px;
  line-height: 40px;
  height: 40px;
  text-align: center;
  vertical-align: top;
}

.weather-icon {
  background: rgba(255,255,255,0.8);
  border: 1px solid rgba(0,0,0,0.2);
  border-radius: 10px;
  height: 40px;
}
.weather-icon img{
  height: 40px;
}
</style>
